import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import pinia from './store'
import 'normalize.css'
import '@/assets/css/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

//引入实现视频播放
import '@/assets/js/jquery-3.2.1.min.js' //jquery
// import '@/assets/js/cch5upload.js' // 视频上传引用
import '@/assets/js/cch5uploadAll.js' // 视频上传引用
import '@/assets/css/quill.bubble.css'
import '@/assets/css/quill.snow.css'
import '@/assets/css/quill.core.css'
// if(process.env.NODE_ENV ==  'production'){
//   console.log = () => {}
// }
const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(router).use(pinia).mount('#app')
